import { render } from "./CustomFieldsIndexPage.vue?vue&type=template&id=5276765c"
import script from "./CustomFieldsIndexPage.vue?vue&type=script&lang=js"
export * from "./CustomFieldsIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__